import code2city from './code2city.json'
// import JSON110100 from './city/110100.json'
// import JSON120100 from './city/120100.json'
// import JSON130100 from './city/130100.json'
// import JSON150100 from './city/150100.json'
// import JSON210100 from './city/210100.json'
// import JSON230100 from './city/230100.json'
import JSON310100 from './city/310100.json'
// import JSON320500 from './city/320500.json'
// import JSON340100 from './city/340100.json'
// import JSON360100 from './city/360100.json'
// import JSON410100 from './city/410100.json'
// import JSON440100 from './city/440100.json'
// import JSON460100 from './city/460100.json'
// import JSON510100 from './city/510100.json'
// import JSON530100 from './city/530100.json'
// import JSON540100 from './city/540100.json'
// import JSON610100 from './city/610100.json'
// import JSON620100 from './city/620100.json'
// import JSON630100 from './city/630100.json'
// import JSON650100 from './city/650100.json'
const cityCode = () => {
  // ;(code2city['110100'] as any).resources = JSON120100
  // ;(code2city['120100'] as any).resources = JSON110100
  // ;(code2city['130100'] as any).resources = JSON130100
  // ;(code2city['150100'] as any).resources = JSON150100
  // ;(code2city['210100'] as any).resources = JSON210100
  // ;(code2city['230100'] as any).resources = JSON230100
  ;(code2city['310100'] as any).resources = JSON310100
  // ;(code2city['320500'] as any).resources = JSON320500
  // ;(code2city['340100'] as any).resources = JSON340100
  // ;(code2city['360100'] as any).resources = JSON360100
  // ;(code2city['410100'] as any).resources = JSON410100
  // ;(code2city['440100'] as any).resources = JSON440100
  // ;(code2city['460100'] as any).resources = JSON460100
  // ;(code2city['510100'] as any).resources = JSON510100
  // ;(code2city['530100'] as any).resources = JSON530100
  // ;(code2city['540100'] as any).resources = JSON540100
  // ;(code2city['610100'] as any).resources = JSON610100
  // ;(code2city['620100'] as any).resources = JSON620100
  // ;(code2city['630100'] as any).resources = JSON630100
  // ;(code2city['650100'] as any).resources = JSON650100
  return code2city as { [key: string]: any }
}
export default cityCode()
